<div class="stepContainer p-0">
    <div class="d-flex justify-content-start col-12 p-0">
        <div class="col-3 p-0">

            <!-- Is Sub Process -->
            <div class="form-group">
                <label class="titleLabel">{{ 'SOP_MANAGEMENT.DEFINE_STEP' | translate }}</label>
                <div class="stepTypes ml-3">
                    <div class="my-2 p-0 d-flex align-items-center">
                        <!-- Use click and preventDefault, so that we can have a confirmation modal without the input being checked. It will be checked from code instead. -->
                        <input (click)="openDisableSubProcessModal(disableSubProcessModal); $event.preventDefault()" [checked]="!isSubProcess" class="custom-control-input" id="disable-subprocess-radio" name="toggle-subprocess" type="radio">
                        <label for="disable-subprocess-radio">{{ 'SOP_MANAGEMENT.SINGLE_STEP' | translate }}</label>
                    </div>
                    <div class="p-0 mt-3 d-flex align-items-center">
                        <input (click)="toggleSubProcess(true)" [checked]="isSubProcess" class="custom-control-input" id="enable-subprocess-radio" name="toggle-subprocess" type="radio">
                        <label for="enable-subprocess-radio">{{ 'SOP_MANAGEMENT.SUB_PROCESS' | translate }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-start col-9 p-0 subStepTitle">
            <!-- Step Title for SA / CA-->
            <div class="bd-input " *ngIf="isSubProcess && (roleId == 1 || roleId == 2)" (click)="stepRef.invalidTitle = undefined; onProcessTitleClicked()">
                <input type="text" id="inputStep" required=""  maxlength="200"
                [value]="layoutService.translateText(title) | labelSanitizer"
                [disabled]="blockCAChanges">
                <label for="inputStep" class="label" [ngClass]="title ? 'filled':'' " >{{ 'SOP_MANAGEMENT.TITLE_SUB_PROCESS' | translate }}</label>
            </div>

            <!-- Step Title for GA / IA-->
            <div class="bd-input " *ngIf="isSubProcess && (roleId == 3 || roleId == 4)">
                <input type="text" id="inputStep" maxlength="200" (focusin)="onFocusInInput()" (focusout)="onFocusOutSOPInput($event, title)"
                [value]="layoutService.translateText(title) | labelSanitizer">
                <label for="inputStep" class="label" [ngClass]="title ? 'filled':'' " >{{ 'SOP_MANAGEMENT.TITLE_SUB_PROCESS' | translate }}</label>
            </div>
        </div>

    </div>

    <div id="step-editor-{{i + 1}}" *ngFor="let card of stepCards; let i = index" class="">
        <hr *ngIf="i>0" class="stepSeparator m-0 mt-4 mb-5 ">
        <!-- left column: title, image -->
        <div class="p-0 d-flex justify-content-between mt-3" [ngClass]="(isSubProcess && i == 0) || (i == 0)? 'subProcess col-9':'col-12'">

            <!-- Sub step Title -->
            <div class="col-4 stepTitle" [ngClass]="(isSubProcess || i == 0)? 'p-0':''">
                <!-- Step title for SA / CA-->
                <div *ngIf="roleId == 1 || roleId == 2" class="bd-input mt-4" (click)="card.invalidTitle = undefined; onTitleClicked(i, card);">
                    <input type="text" id="subProcessTitle" required=""  maxlength="200"
                    class=""
                    [value]="layoutService.translateText(card.title) | labelSanitizer"
                    [ngClass]="(card ? card.invalidTitle : false) ? 'is-invalid' : '' "
                    [disabled]="blockCAChanges">
                    <label for="subProcessTitle" class="label" [ngClass]="card.title ? 'filled':'' " >{{ 'SOP_MANAGEMENT.STEP_TITLE' | translate }} {{i + 1}}</label>
                </div>

                <!-- Step title por GA / IA -->
                <div *ngIf="roleId == 3 || roleId == 4" class="bd-input mt-4">
                    <input type="text" id="subProcessTitle" maxlength="200" (focusin)="onFocusInInput()" (focusout)="onFocusOutSOPInput($event, card.title)"
                    [value]="layoutService.translateText(card.title) | labelSanitizer"
                    [ngClass]="(card ? card.invalidTitle : false) ? 'is-invalid' : '' ">
                    <label for="subProcessTitle" class="label" [ngClass]="card.title ? 'filled':'' " >{{ 'SOP_MANAGEMENT.STEP_TITLE' | translate }} {{i + 1}}</label>
                </div>
            </div>

            <!-- Image -->
            <div class="">
                <div class="card-task m-0" [ngClass]="blockCAChanges ? 'disabled' : ''">
                    <div class="card-task-media" [ngClass]="(card ? card.invalidImage : false) ? 'isinvalid' : '' "
                    (click)="card.invalidImage = undefined; editImage(i)">
                    <img *ngIf="hasImage(card)" [src]="getFullImageUrl(card.imagePath)" class="svg img-fluid">
                    <img *ngIf="!hasImage(card)" class="no-image" src="assets/ph-bhp-layout/svg/no-image.png">
                    </div>
                </div>
                <div *ngIf="isSubProcess" class="custom-control custom-radio custom-control-inline p-0 mt-1">
                    <div (click)="setAsDefaultImage(i)">
                        <input [checked]="isDefaultImage(i)" class="custom-control-input" id="use-in-step-image-{{i}}" name="use-in-step-image" type="radio">
                        <label for="use-in-step-image-{{i}}">{{ 'SOP_MANAGEMENT.USE_AS_DEFAULT_IMAGE' | translate }}</label>
                    </div>
                </div>
                <div class="uploadImgTxt justify-content-end mt-2 d-flex text-container-width-223">
                    <span *ngIf="hasImage(card)" (click)="editImage(i)">{{ 'CONFIGURE.EDIT' | translate }} </span>
                    <span *ngIf="hasImage(card)" (click)="removeImage(i);">{{ 'LAYOUT_MODULE.REMOVE' | translate }}</span>
                    <span *ngIf="!hasImage(card)" (click)="editImage(i)">{{ 'SOP_MANAGEMENT.ADD_IMAGE' | translate }}</span>
                </div>
            </div>
        </div>

        <!-- right column: options -->
        <div class="col-md-12 p-0 stepOptions">
            <div class="form-group">
                <label class="titleLabel">{{ 'SOP_MANAGEMENT.OPTIONS' | translate }}</label>

                <!-- Indications -->
                <div class="col-12 p-0 mt-2 ml-3 d-flex">
                    <div class="custom-control custom-radio p-0 mt-2 col-3" (click)="onHandDisinfectionToggled(i,card,$event)">
                        <input  [checked]="card.hasHandDisinfection" class="indications"
                        id="checkbox-{{i}}-indications" type="checkbox">
                        <label for="checkbox-{{i}}-indications">
                            {{ 'SOP_MANAGEMENT.INDICATIONS_FOR_HAND_DISINFECTION' | translate }}
                        </label>
                    </div>
                    <div *ngIf="card.hasHandDisinfection" class="sop-box p-3 mt-2" >
                        <div class="desinfectionOpt" (click)="onIndicationToggled(i,1,card,$event)">
                            <input  [checked]="card.hasIndication1" id="checkbox-{{i}}-indication-1" type="checkbox">
                            <label for="checkbox-{{i}}-indication-1">
                            {{ 'SOP_MANAGEMENT.BEFORE_TOUCHING_PATIENT' | translate }}
                            </label>
                        </div>
                        <div class="desinfectionOpt" (click)="onIndicationToggled(i,2,card,$event)">
                            <input  [checked]="card.hasIndication2" id="checkbox-{{i}}-indication-2" type="checkbox">
                            <label for="checkbox-{{i}}-indication-2">
                            {{ 'SOP_MANAGEMENT.BEFORE_ASEPTIC_PROCEDURES' | translate }}
                            </label>
                        </div>
                        <div  class="desinfectionOpt" (click)="onIndicationToggled(i,3,card,$event)">
                            <input  [checked]="card.hasIndication3" id="checkbox-{{i}}-indication-3" type="checkbox">
                            <label for="checkbox-{{i}}-indication-3">
                            {{ 'SOP_MANAGEMENT.AFTER_BODY_FLUID_EXPOSURE_RISK' | translate }}
                            </label>
                        </div>
                        <div  class="desinfectionOpt" (click)="onIndicationToggled(i, 4,card,$event)">
                            <input  [checked]="card.hasIndication4" id="checkbox-{{i}}-indication-4" type="checkbox">
                            <label for="checkbox-{{i}}-indication-4">
                            {{ 'SOP_MANAGEMENT.AFTER_TOUCHING_PATIENT' | translate }}
                            </label>
                        </div>
                        <div  class="desinfectionOpt" (click)="onIndicationToggled(i,5,card,$event)">
                            <input  [checked]="card.hasIndication5" id="checkbox-{{i}}-indication-5" type="checkbox">
                            <label for="checkbox-{{i}}-indication-5">
                            {{ 'SOP_MANAGEMENT.AFTER_TOUCHING_PATIENT_SURROUNDINGS' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <!-- Hygiene Relevant -->

                <div class="col-12 ml-3 p-0 mt-4" (click)="onHygieneRelevantToggled(i, card, $event)">
                    <input  [checked]="card.isHygieneRelevant" class="hygiene-relevant" id="checkbox-{{i}}-hygiene" type="checkbox">
                    <label for="checkbox-{{i}}-hygiene">
                        {{ 'SOP_MANAGEMENT.HYGIENE_RELEVANT_STEP' | translate }}
                    </label>
                </div>
                <!-- Situational -->
                <div class="col-12 p-0 mt-4 ml-3 d-flex">
                    <div class=" p-0 col-3" (click)="onSituationalToggled(i, card, $event)">
                        <input  [checked]="isSituational(card)" id="checkbox-{{i}}-situational" type="checkbox">
                        <label for="checkbox-{{i}}-situational">
                            {{ 'SOP_MANAGEMENT.SITUATIONAL' | translate }}
                        </label>
                    </div>
                    <div *ngIf="isSituational(card)" class="form-group col-6 p-0">
                        <!-- Comments for SA / CA -->
                        <div class="bd-input w-100 comments-container" *ngIf="roleId == 1 || roleId == 2">
                            <textarea id="textarea-{{i}}-situational" class="text-comt form-control"
                            (click)="onSituationalCommentsClicked(i)"
                            [ngClass]="(card.isSituational && card.isSituational.trim().length > 0 ) ? 'filled':'' "
                            [value]="layoutService.translateText(card.isSituational)"
                             rows="1" type="text" maxlength="500"
                             ></textarea>
                             <label for="textComment" class="label" [ngClass]="card.isSituational ? 'filled':'' ">{{ 'CONFIGURE.WRITE_COMMENTS_HERE' | translate }}</label>
                             <span class="character-count-text">{{getTranslatedKeyLength(card)}}/500 </span>
                        </div>

                        <!-- Comments por GA / IA -->
                        <div class="bd-input w-100 comments-container" *ngIf="roleId == 3 || roleId == 4">
                            <textarea id="textarea-{{i}}-situational" class="text-comt form-control" (focusin)="onFocusInInput()" (focusout)="onFocusOutSOPInput($event, card.isSituational)" 
                            [ngClass]="(card.isSituational && card.isSituational.trim().length > 0 ) ? 'filled':'' "
                            [value]="layoutService.translateText(card.isSituational) ? layoutService.translateText(card.isSituational) : ''"
                             rows="1" type="text" maxlength="500"
                             ></textarea>
                             <label for="textComment" class="label" [ngClass]="card.isSituational ? 'filled':'' ">{{ 'CONFIGURE.WRITE_COMMENTS_HERE' | translate }}</label>
                             <span class="character-count-text">{{getTranslatedKeyLength(card)}}/500 </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Delete sub step -->
            <div class="col-12 d-flex justify-content-end">
                <button (click)="openDeleteSubStepModal(i, deleteSubStepModal)" *ngIf="isSubProcess" [ngClass]="i==0?'mainStep':''" class="btn-bd-empty square deleteStep"><mat-icon outline>delete</mat-icon></button>
            </div>
        </div>
    </div>
    <!-- Add sub step to process -->
    <div *ngIf="isSubProcess" class="col-12 d-flex justify-content-end">
        <button (click)="addSubStep()" class="btn-bd-empty square addStep"><mat-icon>add</mat-icon></button>
    </div>
    <div  class="col-12 mt-5 d-flex justify-content-end">
        <button (click)="closeStepModal()" class="btn-cancel-bordered-bd separate-buttons">{{ 'INSTITUTION_MANAGEMENT.CLOSE' | translate }}</button>
        <button (click)="openDeleteStepModal(deleteStepModal)" class="btn-bd-empty square "><mat-icon outline>delete</mat-icon></button>
    </div>
</div>


<!-- Modal for removing entire step / process -->
<ng-template #deleteStepModal>
    <div class="modal-body confirm-modal p-0" >
        <div class="modal-header justify-content-between align-items-center ">
            <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
            <a (click)="hideCurrentModal()" class="cursor" data-dismiss="modal"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
        </div>
        <div class="modal-body">
            <p class="">{{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.STEP' | translate }}</p>
        </div>
        <div class="modal-footer">
            <div class="p-2 container-fluid">
                <div class="p-1 justify-content-end align-items-center d-flex">
                    <button (click)="hideCurrentModal()" class="btn-cancel-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
                    <button (click)="deleteStep();hideCurrentModal()" class="ml-3 btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Modal for removing sub step -->
<ng-template #deleteSubStepModal>
    <div class="modal-body confirm-modal p-0" >
        <div class="modal-header justify-content-between align-items-center ">
            <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
            <a (click)="hideCurrentModal()" class="cursor" data-dismiss="modal"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
        </div>
        <div class="modal-body">
            <p class="">{{ 'SOP_MANAGEMENT.CONFIRMATION_DELETE_SUB_PROCESS' | translate }}</p>
            <p *ngIf="stepCards.length == 2" class="">
                {{'SOP_MANAGEMENT.INFORMATION_CHANGE_INTO_SINGLE_STEP' | translate}}</p>
        </div>
        <div class="modal-footer">
            <div class="p-2 container-fluid">
                <div class="p-1 justify-content-end align-items-center d-flex">
                    <button (click)="hideCurrentModal()" class="btn-cancel-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
                    <button (click)="deleteSubStep(deleteSubStepModalState);hideCurrentModal()" class="ml-3 btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Modal for changing to sub process-->
<ng-template #disableSubProcessModal>
    <div class="modal-body confirm-modal p-0" >
        <div class="modal-header p-0 justify-content-between align-items-center ">
            <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
            <a (click)="hideCurrentModal()" class="cursor" data-dismiss="modal"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
        </div>
        <div class="modal-body p-0">
            <p class="">
                {{ 'SOP_MANAGEMENT.CONFIRMATION_MOVE_TO_SINGLE_STEP_LOSS_OF_SUB_PROCESS_STEPS' | translate }}
            </p>
        </div>
        <div class="modal-footer p-0">
            <div class="p-0 container-fluid">
                <div class="p-0 justify-content-end align-items-center d-flex">
                    <button (click)="restoreSubProcessCheck(); hideCurrentModal();" class="btn-cancel-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
                    <button (click)="toggleSubProcess(false);hideCurrentModal()" class="btn-bd-empty">{{ 'EVALUATION.CHANGE' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
